import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const SubGalleryBaseUrl = `${Base_Url}/gallary`;


export const GetGalleryList = async (params) => {
  let url = `${SubGalleryBaseUrl}/getGallaryList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const addUpdateGallary = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${SubGalleryBaseUrl}${url}`, params);
    return res;
  };

//   const res = await postApiWithAuthenticated(`${SubGalleryBaseUrl}${url}`, params);
//   return res;
// };

export const changeGallaryStatus = async (id) => {
  let url = `${SubGalleryBaseUrl}/changeGallaryStatus?GallaryKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const GetGallaryModelData = async (id) => {
    let url = `${SubGalleryBaseUrl}/getGallaryModel?GallaryKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const getAllGallaryList = async (id) => {
    let url = `${SubGalleryBaseUrl}/getAllGallaryList?GallaryCatKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


// export const GetStateLookupList = async () => {
//     const url = `${SubGalleryBaseUrl}/GetStateLookupList`;
  
//     const res = await getListWithAuthenticated(url );
//     return res;
//   };
  
//   export const ChangeStateStatus = async (id,UserKeyID) => {
//     let url = `${SubGalleryBaseUrl}/ChangeStateStatus?StateID=${id}&UserKeyID=${UserKeyID}`;
//     const res = await getListWithAuthenticated(url);
//     return res;
//   };